<mat-toolbar id="app-navbar" fxLayout="row" fxLayoutAlign="space-between center">
    <div fxFlex="10" fxLayout="row" fxLayoutAlign="start center">
      <button mat-icon-button class="back-btn" (click)="goBack()" *ngIf="showBackIcon">
          <mat-icon>arrow_back</mat-icon>
      </button>
    </div>
    <div fxFlex="80" fxLayout="row" fxLayoutAlign="center center">
      Co-Nurse
    </div>
    <div fxFlex="10" fxLayout="row" fxLayoutAlign="end center">
    </div>
</mat-toolbar>